import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api, V1 } from "@/lib/api";

function getSessionId() {
  let sid = localStorage.getItem("sano_sid");
  if (!sid) {
    sid = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("sano_sid", sid);
  }
  return sid;
}

export default function AnalyticsTracker() {
  const loc = useLocation();
  const lastPath = useRef(null);
  useEffect(() => {
    if (lastPath.current === loc.pathname) return;
    lastPath.current = loc.pathname;
    // ignore admin/panel/okul-paneli
    if (/^\/(admin|panel|okul-paneli)/.test(loc.pathname)) return;
    api.post(`${V1}/analytics/track`, {
      type: "pageview",
      path: loc.pathname + loc.search,
      referrer: document.referrer || null,
      session_id: getSessionId(),
    }).catch(() => {});
  }, [loc.pathname, loc.search]);
  return null;
}
